import React from 'react'
import { Link } from 'react-router-dom'

const PortafolioItem = ({type, name, img, description, link}) => {
    return (
        <div className={`col-lg-4 col-md-6 portfolio-item isotope-item filter-${type}`}>
            <div className="portfolio-content h-100">
                <img src={img} className="img-fluid" alt="" />
                <div className="portfolio-info">
                    <h4>{name}</h4>
                    <p>{description}</p>
                    <Link to={`/portfolio-details/${name}`} className="details-link" title="Más detalles"><i className="bi bi-link-45deg"></i></Link>
                </div>
            </div>
        </div>
    )
}

export default PortafolioItem